// @flow
import omitBy from 'lodash/omitBy'

export const diffObject = (a: Object, b: Object): Object => omitBy(a, (v: any, k: any) => b[k] === v)
